import { useCallback, useEffect, useState } from "react";

/**
 * Claro u oscuro. La preferencia se aplica antes de pintar (ver el script en
 * `index.html`), así que aquí solo hay que mantenerla sincronizada.
 *
 * `localStorage` para un tema sí: es una preferencia visual, no una credencial.
 */
const LLAVE = "4drando:tema";
type Tema = "claro" | "oscuro";

const leer = (): Tema | null => {
  try {
    const v = localStorage.getItem(LLAVE);
    return v === "claro" || v === "oscuro" ? v : null;
  } catch {
    return null;
  }
};

export function usarTema() {
  const [tema, setTema] = useState<Tema>(() =>
    leer() ??
    (typeof matchMedia === "function" && matchMedia("(prefers-color-scheme: dark)").matches
      ? "oscuro"
      : "claro"),
  );

  useEffect(() => {
    document.documentElement.classList.toggle("oscuro", tema === "oscuro");
    try {
      localStorage.setItem(LLAVE, tema);
    } catch {
      /* sin almacenamiento: el tema dura lo que la pestaña. */
    }
  }, [tema]);

  const alternar = useCallback(() => setTema((t) => (t === "oscuro" ? "claro" : "oscuro")), []);
  return { tema, alternar };
}
